import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { loadingState } from "store/store";

const Loading = () => {
  const loading = useRecoilValue(loadingState);
  const pathname = useLocation().pathname;

  if (!loading) {
    return null;
  }

  return (
    <div
      className={clsx(
        "fixed z-[1000] top-0 bottom-0 right-0 flex items-center justify-center bg-[rgba(0,0,0,0.2)]",
        pathname.includes("/login") ? "left-0" : "left-14",
      )}
    >
      <div className="size-20 inline-block after:block after:w-16 after:h-16 after:m-2 after:rounded-full after:border-solid after:border-[6px] after:border-[white_transparent_white_transparent] lds-dual-ring"></div>
    </div>
  );
};

export default Loading;
